import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import InlineSVG from 'svg-inline-react'

import { pastelColor} from 'shared/utils/colors'
import { getFullName } from 'shared/utils/helper'
import { getIconByChannelName } from 'shared/utils/channels'

import { useSelector } from 'react-redux'
import * as Selectors from 'state/selectors'

import anon from 'assets/anon_avatar.png'
import bot from 'assets/bot-icon.svg'

const AvatarContainer = styled.div`
  position: relative;
`

const Image = styled.img`
  display: block;
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
`

const BotIcon = styled(InlineSVG)`
  display: block;
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
`

const ImageDiv = Image.withComponent('div')

const CircleWrapper = styled.div`
  background-color: ${props => props.background};
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display:flex;
  align-items: center;
  justify-content:center;
`

const Initials = styled.span`
  color: #FFFFFF;
  font-size: 16rem;
`

const ChatAvatar = ({actor}) => {
  const [error, setError] = useState(false)

  const handleImageError = () => {
    setError(true)
  }

  const name = getFullName(null, actor) || 'Unknown user'
  let picture

  if (!error && typeof actor?.profile?.picture === 'string') {
    picture = <Image
      src={actor?.profile?.picture}
      title={name}
      onError={handleImageError}
    />
  } else if (actor?.role === 'bot') {
    picture = <BotIcon
      src={bot}
      title='System'
      onError={handleImageError}
    />
  } else if (name !== 'Unknown user' && name !== 'Anonymous' && !name?.includes('|')) {
    const initials = name?.split(' ')?.map((n) => n[0]).join('').toUpperCase()
    const backColor = pastelColor(initials)
    picture = <ImageDiv title={name}>
      <CircleWrapper background={backColor}>
        <Initials>{initials}</Initials>
      </CircleWrapper>
    </ImageDiv>
  } else {
    picture = <Image
      src={anon}
      title={name}
      onError={handleImageError}
    />
  }

  return (
    <AvatarContainer>
      {picture}
    </AvatarContainer>
  )
}

ChatAvatar.propTypes = {
  actor: PropTypes.object
}

export default ChatAvatar
